var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"step-header",class:{ 'step-header--inline': _vm.inLine }},[_c('h1',{staticClass:"step-header__title"},[_vm._v(" "+_vm._s(_vm.formattedHeaderText)+" ")]),_c('span',{staticClass:"step-header__sub-title",domProps:{"innerHTML":_vm._s(_vm.formattedSubHeaderText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }